export const QUALIFICATION_NAMES = Object.freeze({
  AGE: 'Age',
  NESTED: 'Nested',
});

export const CHILDREN_QUALIFICATION_NAMES = [
  'Children',
  'Have Children',
  'Child Gender',
  'Child Age',
];
